import { LOGOUT } from '../../actions/auth';

import { CLEAR_STUDENT_DATA } from '../../actions/student';

import {
  FETCH_LESSON_SUMMARY_SENT,
  FETCH_LESSON_SUMMARY_SUCCEEDED,
  FETCH_LESSON_SUMMARY_FAILED,
  CREATE_LESSON_SUMMARY_SENT,
  CREATE_LESSON_SUMMARY_SUCCEEDED,
  CREATE_LESSON_SUMMARY_FAILED,
  UPDATE_LESSON_SUMMARY_SENT,
  UPDATE_LESSON_SUMMARY_SUCCEEDED,
  UPDATE_LESSON_SUMMARY_FAILED,
  CLEAR_LESSON_SUMMARY_DATA,
} from '../../actions/lessonSummary';

import {
  CREATE_LESSON_SUMMARY_RATING_SENT,
  CREATE_LESSON_SUMMARY_RATING_SUCCEEDED,
  CREATE_LESSON_SUMMARY_RATING_FAILED,
} from '../../actions/lessonSummaryRating';

const initialState = {
  summary: null,
  loading: false,
  mutating: false,
};

export default function lessonSummaryReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case LOGOUT:
    case CLEAR_LESSON_SUMMARY_DATA:
    case CLEAR_STUDENT_DATA:
      return initialState;
    case FETCH_LESSON_SUMMARY_SUCCEEDED:
      return {
        ...state,
        loading: false,
        summary: payload.summary,
      };
    case FETCH_LESSON_SUMMARY_SENT:
      return {
        ...state,
        loading: true,
        summary: null,
      };
    case FETCH_LESSON_SUMMARY_FAILED:
      return {
        ...state,
        loading: false,
      };
    case CREATE_LESSON_SUMMARY_SENT:
    case UPDATE_LESSON_SUMMARY_SENT:
    case CREATE_LESSON_SUMMARY_RATING_SENT:
      return {
        ...state,
        mutating: true,
      };
    case CREATE_LESSON_SUMMARY_SUCCEEDED:
    case UPDATE_LESSON_SUMMARY_SUCCEEDED:
    case CREATE_LESSON_SUMMARY_RATING_SUCCEEDED:
      return {
        ...state,
        mutating: false,
        summary: payload.summary,
      };
    case CREATE_LESSON_SUMMARY_FAILED:
    case UPDATE_LESSON_SUMMARY_FAILED:
    case CREATE_LESSON_SUMMARY_RATING_FAILED:
      return {
        ...state,
        mutating: false,
      };
    default:
      return state;
  }
}
